import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { JwtRequest, JwtResponse } from 'src/app/interfaces/jwt.interface';
import { Response, ResponseModel } from 'src/app/interfaces/response.interface';
import { User } from 'src/app/interfaces/user.interface';

@Injectable({
  providedIn: 'root'
})
export class AuthngkService {

  public currentUser: Observable<JwtResponse>;
  private currentUserSubject: BehaviorSubject<JwtResponse>;

  constructor(private httpClient: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<JwtResponse>(JSON.parse(localStorage.getItem('currentUser') || '{}'));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public setCurrentUserValue(jwtResponse) {
    this.currentUserSubject.next(null);
    this.currentUserSubject.next(jwtResponse);
  }

  public get currentUserValue(): JwtResponse {
    return this.currentUserSubject.value;
  }

  logIn(jwtRequest: JwtRequest): Observable<ResponseModel<JwtResponse>> {
    const url = environment.baseApiUrl + '/web/login';
    console.log(url);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<ResponseModel<JwtResponse>>(`${url}`, jwtRequest, { headers });
  }

  async logInAsync(jwtRequest: JwtRequest): Promise<any> {
    const url = environment.baseApiUrl + '/web/login';
    console.log(url);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return await this.httpClient.post<ResponseModel<JwtResponse>>(`${url}`, jwtRequest, { headers }).toPromise();
  }

  logOut() {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentSync');
    localStorage.removeItem('idCurrentSync');
    localStorage.removeItem('statusCurrentSync');
    this.currentUserSubject.next(null);
  }
}
